import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import { Controller, useForm } from 'react-hook-form'
import { useRenameAiThread } from '../../../../../api/denaliAssistant'
import { decipherError } from '../../../../../utils/decipherError'
import SydLabel from '../../../../../components/commonDesign/SydLabel'
import SydInput from '../../../../../components/commonDesign/SydInput'
import SydModalActions from '../../../../../components/commonDesign/SydModal/SydModalActions'
import SydButton from '../../../../../components/commonDesign/Button'

const useSubmitter = (form, threadId, onComplete) => {
  const { handleSubmit, clearErrors } = form
  const { mutateAsync: renameThread, isLoading } = useRenameAiThread()
  const onSubmit = useCallback(async (formData) => {
    const command = {
      threadId,
      name: formData.name || null
    }

    try {
      form?.clearErrors?.()
      const result = await renameThread(command)
      onComplete(result)
    } catch (err) {
      form.setError('root', {
        type: 'custom',
        message: decipherError(err) || 'Something unexpected happened while creating the scheduled digest.'
      })
    }
  }, [form, threadId, onComplete, renameThread])

  const submitter = useCallback(async (e) => {
    const onValid = async (form) => {
      await onSubmit(form)
    }
    const onInvalid = (errors) => {
      console.error(errors)
    }
    clearErrors()
    const handler = handleSubmit(onValid, onInvalid)
    await handler(e)
  }, [handleSubmit, clearErrors, onSubmit])

  return {
    submitter,
    processing: isLoading
  }
}

function RenameThreadForm ({ thread, onCancel, onComplete }) {
  const form = useForm({
    mode: 'onChange',
    defaultValues: {
      name: thread.name
    }
  })
  const { submitter, processing } = useSubmitter(form, thread?.threadId, onComplete)

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Controller
            name='name'
            control={form.control}
            rules={{
              maxLength: { value: 256, message: 'Maximum 256 characters' }
            }}
            render={({ field }) => (
              <SydLabel label='Name' required style={{ width: '100%' }}>
                <div>
                  <SydInput
                    autoFocus
                    width='inherit'
                    name='name'
                    disabled={processing}
                    {...(field)}
                  />
                </div>
              </SydLabel>
            )}
          />
        </Grid>

        {/* Actions */}
        <Grid item xs={12}>
          <SydModalActions>
            {/* {error && <div className='__error'>{error}</div>} */}
            <SydButton
              disabled={processing}
              variant='ghost'
              size='md'
              onClick={onCancel}
            >
              Cancel
            </SydButton>
            <SydButton
              processing={processing}
              variant='primary'
              size='md'
              onClick={submitter}
            >
              Save Changes
            </SydButton>
          </SydModalActions>
        </Grid>
      </Grid>
    </div>
  )
}

RenameThreadForm.propTypes = {
  thread: PropTypes.shape({
    threadId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  onComplete: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

export default RenameThreadForm
